"use client";
import { useState } from "react";

export default function LoginForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setErr(null);
    const res = await fetch("/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });
    if (res.ok) {
      window.location.href = "/admin";
    } else {
      const j = await res.json().catch(() => ({}));
      setErr(j.error ?? "Identifiants incorrects.");
      setLoading(false);
    }
  };

  return (
    <main style={{ minHeight: "100vh", background: "#1a1714", color: "var(--cream)", display: "flex", alignItems: "center", justifyContent: "center", padding: 48 }}>
      <div style={{ maxWidth: 420, width: "100%" }}>
        <div className="bast-wordmark" style={{ fontSize: 28, color: "var(--cream)", marginBottom: 36, textAlign: "center" }}>BASTIDE</div>
        <div className="bast-eyebrow" style={{ color: "var(--laiton-hi)", textAlign: "center", display: "block", marginBottom: 14 }}>
          Back-office
        </div>
        <h2 className="bast-h2" style={{ color: "var(--cream)", textAlign: "center", marginBottom: 32, fontSize: 32 }}>
          Connexion
        </h2>
        <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <input
            type="email"
            required
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="bast-input"
            style={{ background: "rgba(243,236,223,0.06)", color: "var(--cream)", borderColor: "rgba(243,236,223,0.18)" }}
            autoFocus
          />
          <input
            type="password"
            required
            placeholder="Mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="bast-input"
            style={{ background: "rgba(243,236,223,0.06)", color: "var(--cream)", borderColor: "rgba(243,236,223,0.18)" }}
          />
          {err && <span className="bast-small" style={{ color: "#E08A78" }}>{err}</span>}
          <button type="submit" disabled={loading || !email || !password} className="bast-btn bast-btn--brass" style={{ justifyContent: "center", marginTop: 8 }}>
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>
      </div>
    </main>
  );
}
